
export const environment = {
  production: false,
  connections: {

    SignalService: 'none',
    SettingService: 'none',
    MediatipService: 'none',
    UserService: 'none',
    LDVService: 'none',
    KatalogWebapi: 'none',

    CommonWebApi: 'none',
    DocumentService: 'none',
    AdvWebapi: 'none',
    ADVSortimentWebapi: 'none',
    TaskListService : 'none',


  },
  user: {
    id: 1,
    userId: 7,
    name: 'Peter Maier'
  },

  managers: [ '10001E', '100021' ],
  wups: [ '100022', '10001F' ],

  admins: [ '10007S' ],
  contacts: [ '10007T' ],
  mandant: [ "100051" ],
  moebelEditorUrl: "",
  planogrammServiceUrl: "",
  lieferantenPortalUrl: "",
  elasticSearchUrl: "",
  graphQLUrlSortimentieren: "",
  FeatureToggle: [],
  olaServiceUrl: "",
  dispolistUrl: "",
  FisSnippet: ""

};

